import Plyr from 'plyr/dist/plyr.polyfilled.js';

export default {
  playlist: null,
  display: {
    video: null,
    title: null,
    desc: null,
  },
  plyr: null,

  _bindEvents() {

    [].forEach.call(this.playlist, video => {
      video.addEventListener('click', e => {
        e.preventDefault();
        this.changeVideo(video);
      });
    });

  },

  init() {
    this.playlist = document.querySelectorAll('.video-thumbnail');
    this.display.video = document.querySelector('.youtube-feed__video');
    this.display.title = document.querySelector('.youtube-feed__title');
    this.display.desc = document.querySelector('.youtube-feed__desc');

    if ( this.display.video ) {
      this.plyr = new Plyr(this.display.video);
      this._bindEvents();
    }
  },

  changeVideo(video) {

    this.plyr.source = {
      type: 'video',
      sources: [
        {
          src: video.getAttribute('data-video-id'),
          provider: 'youtube',
        },
      ],
    };

    this.display.title.textContent = video.getAttribute('data-video-title');
    this.display.desc.textContent = video.getAttribute('data-video-desc');

  },

}

